import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TableColumn } from '../../interfaces/table-column.interface';
import { OrderStatus, PaymentType, SubscriptionModel } from '../../../shared/service-proxies/event-service-proxy';
import { ModalService } from '../../services/modal/modal.service';
import { ErrorService } from '../../services/error/error.service';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrl: './table.component.scss',
    standalone: false
})
export class TableComponent<T> {
  @Input() columns: TableColumn[];
  @Input() data: T[] = [];
  @Input() heightTable: any = {};
  @Input() dataMissing: boolean|string = true;
  @Input() path: string = '';
  @Input() isLoading: boolean = true;
  @Input() count: number = 0;
  @Input() btnProlong: boolean = false;
  @Input() prolong: string = '';

  @Input() getStatus!: (status: OrderStatus) => string; 
  @Input() getPaymentType!: (type: PaymentType) => string; 

  @Input() pagination: { currentPage: number; totalItems: number; pageSize: number } | null = null;

  @Output() pageChange = new EventEmitter<number>();
  @Output() modalProlong = new EventEmitter<void>();

  countSkeleton: number = 0;

  row: T;
  copiedTooltipVisible: number | null = null;
  private copyTimeoutId: any;

  constructor(public modalService: ModalService, private errorService: ErrorService) {}
  
  ngOnChanges() {
    this.countSkeleton = this.count;
  }
  onPageChange(newPage: number): void {
    this.pageChange.emit(newPage);
  }
  isStatusOrActive(field: string): boolean {
    return field === 'status' || field === 'status.name' || field === 'isActive' || field === 'type' || field === 'btnProlong';
  }
  getDynamicText(field: string, row: any): string {
    if (field === 'status') { 
      return this.getStatus(row.status);
    } else if (field === 'status.name') {
      return row.status.name
    } else if (field === 'isActive') {
      return row.isActive ? 'Активный' : 'Неактивный';
    } else if (field === 'type') {
      return this.getPaymentType(row.type);
    } 
    
  }

  addCurrencyToPrice(column: TableColumn, row: any): boolean {
     return (column.field === 'total' || column.field === 'orderProduct.price' || column.field === 'price') && (row?.total > 0 || row?.orderProduct?.price > 0 || row?.price > 0)
  }
  openModal(row: any, event: Event, popup: string) {
    event.stopPropagation();
    event.preventDefault();
    this.row = row;
    (popup === 'subscription' && !row.activatedAt) ? 
    this.errorService.handleError('', 'Невозможно продлить неактивированную подписку') :
    this.modalService.openModal(popup);
  }

  copyTextToClipboard(text: string = '', index: number, event: Event): void {
    event.stopPropagation();
    event.preventDefault();

    this.copiedTooltipVisible = index;
    
    if (this.copyTimeoutId) {
      clearTimeout(this.copyTimeoutId);
    }

    navigator.clipboard.writeText(text).then(() => {
      this.copyTimeoutId = setTimeout(() => {
        this.copiedTooltipVisible = null;
        this.copyTimeoutId = null;
      }, 500);
    })
  }

}
